<form [formGroup]="totpForm">
  <div class="ids-my-3">
    <id-input>
      <label>Ange Personnummer (ÅÅÅÅMMDDXXXX)</label>
      <input type="text" formControlName="personId" />
      <span aria-hidden="true" class="ids-icon-user ids-icon--m ids-icon--color-preset-1"></span>
    </id-input>
  </div>
  <id-input>
    <label>Engångskod</label>
    <input type="text" formControlName="code" />
    <span aria-hidden="true" class="ids-icon-shield-locked-filled ids-icon--m ids-icon--color-preset-1"></span>
  </id-input>
</form>

<div class="ids-mt-5 flex flex-center">
  <id-link>
    <a href="javascript:void(0);" (click)="submitForm()">Logga In</a>
  </id-link>
</div>
